import { createContext } from "react";

const AlchContext = createContext();

export default AlchContext;